<template>
  <div class="mb-5">
    <img :class="[$style['image-icon'], 'left']" src="@/assets/icons/svg/date.svg"/>
    <span :class="$style['label-text']">{{ preloadedItem.name }}</span>

    <div class="input-mb input-box d-flex flex-nowrap">
      <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
        <template v-slot:activator="{ on }">
          <v-text-field
          prepend-icon="event"
          :value="computedDateFormattedMomentjs"
          :placeholder=preloadedItem.placeholder
          readonly
          v-on="on">
            <template v-slot:append-outer>
              <span v-if="date" class="cursor-pointer" @click="clearDate()">
                Clear
              </span>
            </template>
            <template v-if='letDelete' slot='append'>
            <div
              :class='$style["delete-rounded-button"]'
              width='24'
              height='24'
              min-width='24'
              @click='$emit("delete")'>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color='#c3c3c3' v-bind="attrs" v-on="on">
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>Remove custom field</span>
              </v-tooltip>
            </div>
          </template>
          </v-text-field>
        </template>
        <v-date-picker v-model="date" @change="menu=false" />
      </v-menu>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { writingViewBaseMixin } from '@/components/customFields/commonMixins/_helpers/writingViewBase.mixin'
import { mapGetters } from 'vuex'
export default {
  mixins: [writingViewBaseMixin],
  data: function () {
    return {
      nameRules: [(date) => !!date || 'Please enter date'],
      date: null,
      menu: false
    }
  },
  computed: {
    ...mapGetters('user', ['getDateTimeFormat']),
    computedDateFormattedMomentjs() {
      return this.date && this.date !== null ? moment(this.date).utc(true).format('dddd, MMMM Do YYYY') : ''
    }
  },
  created () {
    if (this.preloadedItem.value && this.preloadedItem.value !== null) {
      this.date = moment(this.preloadedItem.value).utc(true).format('YYYY-MM-DD')
    }
  },
  watch: {
    date() {
      if (this.date === null) {
        this.preloadedItem.value = null
      } else {
        this.preloadedItem.value = moment(this.date).utc(true).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    clearDate() {
      this.date = null
    }
  }
}
</script>

<style lang="scss" module src="../commonStyles/index.module.scss"></style>
